import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import useDocumentMeta from "@/hooks/useDocumentMeta";

const coverage = [
  {
    icon: "ri-newspaper-line",
    title: "娱乐资讯",
    desc: "明星动态、行业趋势、活动现场，第一时间为你整理最新娱乐风向。",
  },
  {
    icon: "ri-movie-2-line",
    title: "影视推荐",
    desc: "涵盖剧集、电影与动漫，按类型、地区、评分多维推荐，帮你快速发现佳作。",
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "互动社区",
    desc: "真实、友善的讨论氛围，让每一位娱乐爱好者都能畅所欲言、分享观点。",
  },
  {
    icon: "ri-trophy-line",
    title: "榜单与专题",
    desc: "定期整理口碑榜、热度榜与专题策划，让优质内容更容易被看见。",
  },
];

const promises = [
  "内容真实可靠，来源清晰可追溯",
  "界面清爽易读，阅读体验舒适",
  "尊重每一位用户，鼓励理性友善的讨论",
  "持续更新，努力提供有价值的娱乐信息",
];

export default function About() {
  useDocumentMeta(
    "关于我们 - 色花堂",
    "了解色花堂的网站定位、内容范围与联系方式，我们致力于为娱乐爱好者提供有价值的资讯与社区平台。",
  );

  return (
    <div>
      <section className="border-b border-background-200 bg-background-50">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-8 md:py-10">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
          <h1 className="mt-5 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
            关于色花堂
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-500">
            一个为娱乐爱好者而生的综合平台，让发现内容与分享观点都变得简单。
          </p>
        </div>
      </section>

      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-8">
        <section className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
          <h2 className="font-heading text-xl font-extrabold text-foreground-950">网站简介</h2>
          <div className="mt-4 flex flex-col gap-4">
            <p className="text-base leading-loose text-foreground-800">
              色花堂定位为一个集娱乐新闻、影视推荐与社区互动于一体的综合娱乐平台。我们相信，娱乐不只是消遣，更是连接人与人的方式。
            </p>
            <p className="text-base leading-loose text-foreground-800">
              在这里，你可以浏览最新的娱乐资讯，发现优质的影视作品，也可以进入社区参与讨论、分享你的看法。无论你是影视剧粉丝、娱乐资讯关注者，还是喜欢社交交流的新朋友，都能在色花堂找到属于自己的角落。
            </p>
          </div>
        </section>

        <section className="mt-8">
          <h2 className="font-heading text-xl font-extrabold text-foreground-950">内容涵盖</h2>
          <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {coverage.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h2 className="font-heading text-xl font-extrabold text-foreground-950">我们的承诺</h2>
            <ul className="mt-4 flex flex-col gap-3">
              {promises.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-check-line text-base" aria-hidden="true"></i>
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-background-200 bg-secondary-950 p-6 text-background-100 md:p-8">
            <h2 className="font-heading text-xl font-extrabold text-background-50">联系方式</h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              如果你有内容合作、意见反馈或任何建议，欢迎通过以下方式联系我们：
            </p>
            <ul className="mt-5 flex flex-col gap-3 text-sm">
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-mail-line text-base" aria-hidden="true"></i>
                </span>
                <span>邮箱：hello@sehuatang.example</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-wechat-line text-base" aria-hidden="true"></i>
                </span>
                <span>微信公众号：色花堂娱乐</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-time-line text-base" aria-hidden="true"></i>
                </span>
                <span>服务时间：每日 09:00 - 22:00</span>
              </li>
            </ul>
            <Link
              to="/"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-home-4-line text-base" aria-hidden="true"></i>
              回到首页
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}